<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
    <div>
      <div v-if="erroGuidFaltando" class="p-50">
        <b-card class="text-center f-g">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.2 132.2" class="banner-svg">
            <circle
              class="path circle"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="34.4"
              y1="37.9"
              x2="95.8"
              y2="92.3"
            ></line>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="95.8"
              y1="38"
              x2="34.4"
              y2="92.2"
            ></line>
          </svg>
          <h4>Desculpe, não conseguimos processar seu pedido</h4>
          <h5>Verifique seu e-mail novamente ou entre em contato conosco!</h5>
        </b-card>
      </div>
      <div v-if="sucesso" class="p-50">
        <b-card class="text-center f-g">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.2 132.2" class="banner-svg">
            <circle
              class="path circle"
              fill="none"
              stroke="#73AF55"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <polyline
              class="path check"
              fill="none"
              stroke="#73AF55"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              points="100.2,40.2 51.5,88.8 29.8,67.5 "
            ></polyline>
          </svg>
          <h4>Parabéns, seu cadastro foi ativado com sucesso!</h4>
        </b-card>
      </div>
      <div v-if="problema" class="p-50">
        <b-card class="text-center f-g">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.2 132.2" class="banner-svg">
            <circle
              class="path circle"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="34.4"
              y1="37.9"
              x2="95.8"
              y2="92.3"
            ></line>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="95.8"
              y1="38"
              x2="34.4"
              y2="92.2"
            ></line>
          </svg>
          <h4>Desculpe, não conseguimos achar esse cadastro</h4>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";

export default {
  name: "Login",
  components: { Loading },
  data() {
    return {
      isLoading: true,
      erroGuidFaltando: false,
      sucesso: false,
      problema: false
    };
  },
  methods: {
    handleSubmit() {
      window.location.href = "http://www.accesys.com.br/supermercado/";
    }
  },
  beforeMount() {
    this.isLoading = true;
    let guidParametro = this.$route.query.guid;
    if (guidParametro != undefined && guidParametro != "") {
      axios
        .get(
          `${config.default.servidor}/registro/verificar-email/` +
            guidParametro,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          console.log(response.data);
          if (!response.data.error) {
            this.sucesso = true;
            this.problema = false;
          } else {
            this.sucesso = false;
            this.problema = true;
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.sucesso = false;
          this.problema = true;
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
      this.erroGuidFaltando = true;
    }
  }
};
</script>
